import { Button, ButtonProps, BoxProps } from '@chakra-ui/react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

interface Props extends ButtonProps {
  disabled?: boolean;
  href?: string;
  icon?: any;
  linkStyle?: Pick<BoxProps, 'color' | 'fontSize' | 'fontWeight'>;
}

export const SidebarLink = (props: Props) => {
  const { children, href, linkStyle, ...buttonProps } = props;
  return (
    <Button
      disabled={props.disabled}
      fontSize={linkStyle?.fontSize || 'lg'}
      variant='ghost'
      width='full'
      justifyContent='start'
      gap='3'
      color={linkStyle?.color || 'fg.muted'}
      fontWeight={linkStyle?.fontWeight}
      _hover={{
        bg: 'colorPalette.subtle',
        color: 'colorPalette.fg'
      }}
      _currentPage={{
        color: 'colorPalette.fg',
        textDecoration: 'underline'
      }}
      asChild
      {...buttonProps}>
      <a href={href}>
        {<FontAwesomeIcon icon={props.icon} />}
        {children}
      </a>
    </Button>
  );
};
